import api from './api'

export default {
  list(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/mistreatment-types', { params })
  },
  show(id) {
    return api.get(`/partner-licensings/:partnerLicensingId/mistreatment-types/${id}`)
  },
  update(id, body) {
    return api.put(`/partner-licensings/:partnerLicensingId/mistreatment-types/${id}`, body)
  },
  create(body) {
    return api.post('/partner-licensings/:partnerLicensingId/mistreatment-types', body)
  },
  changeOsmAssuntoId(id, assuntoId) {
    return api.patch(`/partner-licensings/:partnerLicensingId/mistreatment-types/${id}/change-osm-assunto-id/${assuntoId}`)
  },
  clearOsmAssuntoId(id) {
    return api.patch(`/partner-licensings/:partnerLicensingId/mistreatment-types/${id}/clear-osm-assunto-id`)
  },
}
